var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _rect3, _rect4, _rect5, _path61, _path62, _path63;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFonts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(70.09 81.52)",
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M131.232 508.914c56.092 7.959 104.983-5.306 145.157-40.932l67.083 3.79-36.384 106.878c-40.554 64.43-98.92 77.695-159.18 73.905L131.23 508.914z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M156.245 533.17l10.991 97.782c49.65-.379 89.823-16.676 119.764-62.156l26.53-76.558-29.562-1.516c-37.52 30.699-80.348 43.964-127.723 42.448z",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156.245 533.17l6.822 57.987c68.6-8.338 122.417-36.384 150.084-98.919l-29.562-1.516c-37.52 30.699-80.348 43.964-127.344 42.448z",
    vectorEffect: "non-scaling-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M147.529 425.155c62.914 0 113.7 50.786 113.7 113.7s-50.786 113.7-113.7 113.7-113.7-50.786-113.7-113.7 51.165-113.7 113.7-113.7z",
    vectorEffect: "non-scaling-stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M147.529 447.137c-50.407 0-90.96 40.932-90.96 90.96 0 50.407 40.932 90.96 90.96 90.96 50.407 0 90.96-40.932 90.96-90.96.378-50.407-40.554-90.96-90.96-90.96z",
    vectorEffect: "non-scaling-stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.529 447.137c-30.7 0-58.366 15.16-74.663 39.037 3.032 47.754 42.827 85.654 90.96 85.654 30.699 0 58.366-15.16 74.663-39.037-2.654-47.754-42.449-85.654-90.96-85.654z",
    vectorEffect: "non-scaling-stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M135.78 441.452c46.996 0 84.896 37.9 84.896 84.896s-37.9 84.896-84.896 84.896-84.897-37.9-84.897-84.896 37.9-84.896 84.896-84.896z",
    vectorEffect: "non-scaling-stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M129.715 418.712c46.996 0 85.275 38.279 85.275 85.275s-38.279 85.275-85.275 85.275-85.275-38.279-85.275-85.275c.38-46.996 38.658-85.275 85.275-85.275z",
    vectorEffect: "non-scaling-stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M138.054 451.306c-37.521 0-67.841 30.32-67.841 67.841 0 37.521 30.32 67.841 67.84 67.841 37.522 0 67.842-30.32 67.842-67.841-.38-37.521-30.7-67.841-67.842-67.841z",
    vectorEffect: "non-scaling-stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M87.305 349.734c1.516-47.754 72.39-50.407 74.284 0 20.845-34.868 86.033-15.539 65.567 39.037 1.137 4.548 1.895 8.717 2.653 12.886 35.247 1.895 46.996 57.229-1.516 74.284-4.169 15.16-10.233 28.425-18.95 39.037-41.69 35.626-54.955 6.443-77.316-17.813-21.603.758-81.106-14.781-64.43 40.932-37.9-23.877-62.535-72.768-43.964-145.157-25.772-57.608 42.07-79.211 63.672-43.206z",
    vectorEffect: "non-scaling-stroke"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M46.336 401.657c-9.096 34.868-9.475 74.284 15.539 102.709 34.868 39.795 105.74 37.9 132.65-12.128 14.402-27.288 13.644-61.019 7.58-90.581-51.923-11.749-104.604-9.854-155.77 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M46.336 401.657c-9.096 34.868-9.475 74.284 15.539 102.709 15.918 18.192 39.037 27.667 62.535 28.046V393.319c-26.151.379-52.302 3.411-78.074 8.338z",
    vectorEffect: "non-scaling-stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M80.445 428.187c-4.926 19.329-5.305 41.69 9.097 57.229 19.328 22.361 58.744 21.224 73.904-7.201 8.339-15.16 7.96-33.731 4.17-50.407-28.804-6.064-58.745-4.927-87.17.379z",
    vectorEffect: "non-scaling-stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M195.282 349.734c10.612 0 19.708 9.096 19.708 19.708 0 10.612-9.096 19.708-19.708 19.708-10.612 0-19.708-9.096-19.708-19.708 0-10.612 9.096-19.708 19.708-19.708zm-71.252 25.014c10.613 0 19.709-9.096 19.709-19.708 0-10.612-9.097-19.708-19.709-19.708v39.416z",
    vectorEffect: "non-scaling-stroke"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M124.03 374.748v-39.037c-10.611 0-19.707 9.096-19.707 19.708 0 10.991 8.717 19.708 19.708 19.329zm-67.462-22.74c10.613 0 19.709 9.096 19.709 19.708 0 10.612-9.097 19.708-19.709 19.708-10.611 0-19.707-9.096-19.707-19.708 0-10.612 9.096-19.708 19.708-19.708z",
    vectorEffect: "non-scaling-stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M217.264 421.365c10.612 0 19.708 9.096 19.708 19.708 0 10.612-9.096 19.708-19.708 19.708-10.612 0-19.708-9.096-19.708-19.708 0-10.991 8.717-19.708 19.708-19.708z",
    vectorEffect: "non-scaling-stroke"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M893.4 654.071c-4.548-59.124-31.078-101.572-84.138-124.691l10.233-40.932 84.896-22.74c73.905 22.361 103.088 69.357 117.111 128.86L893.4 654.071z",
    vectorEffect: "non-scaling-stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M911.213 621.477l84.517-39.416c-14.78-49.27-39.416-81.485-91.339-93.992l-66.325 17.813-3.032 10.991c40.932 23.877 65.567 59.503 76.18 104.604z",
    vectorEffect: "non-scaling-stroke"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M811.915 663.925c-18.95-57.987 12.128-120.522 70.115-139.472 57.987-18.95 120.522 12.128 139.472 70.115 18.95 57.987-12.128 120.522-70.115 139.472-58.366 19.329-120.522-12.128-139.472-70.115z",
    vectorEffect: "non-scaling-stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M830.107 657.861c15.54 48.133 67.462 73.905 115.216 57.987 48.133-15.539 73.905-67.462 57.987-115.216-15.539-48.133-67.462-73.905-115.216-57.987-48.133 15.539-74.284 67.083-57.987 115.216z",
    vectorEffect: "non-scaling-stroke"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1007.1 616.929c-.758-5.685-1.895-10.612-3.79-16.297-15.538-48.133-67.461-73.905-115.215-57.987-14.781 4.927-27.667 12.886-37.142 23.498.758 5.685 1.895 10.612 3.79 16.297 15.917 48.133 67.461 73.905 115.215 57.987 14.781-4.927 27.288-13.265 37.142-23.498z",
    vectorEffect: "non-scaling-stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M791.07 692.35c-18.192-54.576 11.37-113.7 66.325-131.513 54.577-18.192 113.7 11.37 131.514 66.325 18.192 54.576-11.37 113.7-66.325 131.513-54.576 18.192-113.7-11.749-131.513-66.325z",
    vectorEffect: "non-scaling-stroke"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M812.294 685.528c-14.023-43.206 9.475-89.065 51.923-103.467 43.206-14.023 89.065 9.475 103.467 51.923 14.023 43.206-9.475 89.065-51.923 103.467-43.206 14.402-89.444-9.096-103.467-51.923z",
    vectorEffect: "non-scaling-stroke"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M808.884 646.87c4.927-29.562 25.393-54.955 55.334-65.188 43.206-14.023 89.065 9.475 103.467 51.923 2.274 6.822 3.79 13.644 4.169 20.466-53.06 33.731-122.039 26.151-162.97-7.201z",
    vectorEffect: "non-scaling-stroke"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M430.642 22.657c41.69 0 75.042 35.626 75.042 79.59 0 43.964-33.353 79.59-75.043 79.59-41.69 0-75.042-35.626-75.042-79.59 0-43.964 33.352-79.59 75.042-79.59z",
    vectorEffect: "non-scaling-stroke"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M430.642 44.639c-30.7 0-53.06 27.667-53.06 57.608 0 29.562 22.36 57.608 53.06 57.608s53.06-27.667 53.06-57.608c0-29.941-22.361-57.608-53.06-57.608z",
    vectorEffect: "non-scaling-stroke"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#63300f",
    d: "M430.642 66.621c-18.95 0-31.078 17.813-31.078 35.626 0 17.434 12.507 35.626 31.078 35.626 18.95 0 31.078-17.813 31.078-35.626 0-17.434-12.508-35.626-31.079-35.626z",
    vectorEffect: "non-scaling-stroke"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M750.139 22.657c41.69 0 75.042 35.626 75.042 79.59 0 43.964-33.352 79.59-75.042 79.59-41.69 0-75.042-35.626-75.042-79.59 0-43.964 33.352-79.59 75.042-79.59z",
    vectorEffect: "non-scaling-stroke"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M750.139 44.639c-30.7 0-53.06 27.667-53.06 57.608 0 29.562 22.36 57.608 53.06 57.608s53.06-27.667 53.06-57.608c0-29.941-22.361-57.608-53.06-57.608z",
    vectorEffect: "non-scaling-stroke"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M750.139 66.621c-18.95 0-31.078 17.813-31.078 35.626 0 17.434 12.507 35.626 31.078 35.626 18.95 0 31.078-17.813 31.078-35.626 0-17.434-12.507-35.626-31.078-35.626z",
    vectorEffect: "non-scaling-stroke"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M559.88 59.799c12.886 0 23.877 10.612 23.877 23.877 0 12.886-10.612 23.877-23.877 23.877-12.886 0-23.877-10.612-23.877-23.877.38-12.886 10.991-23.877 23.877-23.877zm60.64 0c12.886 0 23.877 10.612 23.877 23.877 0 12.886-10.612 23.877-23.877 23.877-12.886 0-23.877-10.612-23.877-23.877.38-12.886 10.991-23.877 23.877-23.877z",
    vectorEffect: "non-scaling-stroke"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f3e13",
    d: "M868.008 159.097v147.81l1.516.379c21.603 8.717 35.247 28.425 35.247 51.544v106.499L590.58 569.175 276.389 467.982V359.209c0-23.498 13.644-43.206 35.247-51.544l1.516-.379V158.718c0-102.33 554.856-102.33 554.856.379z",
    vectorEffect: "non-scaling-stroke"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#b85a1b",
    d: "M338.166 164.782v159.559l-12.886 5.306c-14.402 5.685-23.498 18.95-23.498 34.489V476.32l288.798 92.855 288.798-95.129v-109.91c0-15.539-9.096-28.804-23.498-34.489l-12.886-5.306V164.782c0-75.8-504.45-75.8-504.828 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1762f",
    d: "M338.166 164.782v159.559l-12.886 5.306c-14.402 5.685-23.498 18.95-23.498 34.489V476.32l288.798 92.855v-61.019c-100.056.379-200.112-65.188-173.582-194.806H590.58V108.311c-126.207 0-252.414 18.95-252.414 56.471z",
    vectorEffect: "non-scaling-stroke"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5895b",
    d: "M403.012 279.619h375.59c53.438 281.976-432.819 279.702-375.59 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5895b",
    d: "M421.546 301.601c-5.306 43.585 4.169 85.654 36.384 118.248 34.11 34.11 86.033 48.891 133.407 48.891 45.86-.379 94.371-14.781 128.102-47.375 33.731-32.594 44.343-75.042 39.795-119.764H421.545z",
    vectorEffect: "non-scaling-stroke"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fad395",
    d: "M653.531 433.114c25.393 32.594 98.92 19.329 76.937-49.649l-76.937 49.649z",
    vectorEffect: "non-scaling-stroke"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M630.412 425.913c28.425 36.384 120.522 14.781 99.298-64.051l-99.298 64.051z",
    vectorEffect: "non-scaling-stroke"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M655.01 406.963c5.685-1.516 10.99 2.274 12.886 8.338 1.516 6.064-1.516 12.128-7.201 13.644s-10.992-2.274-12.887-8.338c-1.516-5.685 1.516-12.128 7.201-13.644zm60.26-41.311c5.685-1.516 11.37 2.274 12.886 8.338 1.516 6.064-1.516 12.128-7.2 13.644s-11.37-2.274-12.887-8.338c-1.516-6.064 1.516-12.507 7.201-13.644z",
    vectorEffect: "non-scaling-stroke"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad6151",
    d: "M692.19 439.936c20.086-6.822 37.52-22.74 40.552-48.512-16.676-2.274-44.722 21.603-40.553 48.512z",
    vectorEffect: "non-scaling-stroke"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fad395",
    d: "M441.632 279.619h297.894c42.07 201.249-342.995 199.354-297.894 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M590.617 394.077c1.895-12.128 6.443-23.498 14.023-33.352 35.626-5.685 66.704-32.594 56.85-81.485a210.642 210.642 0 00-70.494-12.128l-14.402 46.238 14.023 80.727z",
    vectorEffect: "non-scaling-stroke"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#63300f",
    d: "M590.58 394.077c-1.895-12.128-6.443-23.498-14.023-33.352-35.626-5.685-66.704-32.594-56.85-81.485a210.642 210.642 0 0170.494-12.128l.379 126.965z",
    vectorEffect: "non-scaling-stroke"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad6151",
    d: "M537.899 286.441c35.247-9.475 70.115-9.475 105.74 0 14.402 36.763-122.038 36.384-105.74 0z",
    vectorEffect: "non-scaling-stroke"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M533.73 184.111c21.982 0 39.795 17.813 39.795 39.795 0 21.982-17.813 39.795-39.795 39.795-21.982 0-39.795-17.813-39.795-39.795 0-21.982 17.813-39.795 39.795-39.795z",
    vectorEffect: "non-scaling-stroke"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1d23",
    d: "M536.761 197.755c16.297 0 29.562 13.265 29.562 29.562s-13.265 29.562-29.562 29.562-29.562-13.265-29.562-29.562c-.379-16.297 12.886-29.562 29.562-29.562z",
    vectorEffect: "non-scaling-stroke"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M648.188 184.111c-21.982 0-39.795 17.813-39.795 39.795 0 21.982 17.813 39.795 39.795 39.795 21.982 0 39.795-17.813 39.795-39.795 0-21.982-17.813-39.795-39.795-39.795z",
    vectorEffect: "non-scaling-stroke"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1d23",
    d: "M645.155 197.755c-16.297 0-29.562 13.265-29.562 29.562s13.265 29.562 29.562 29.562 29.562-13.265 29.562-29.562c.38-16.297-13.265-29.562-29.562-29.562z",
    vectorEffect: "non-scaling-stroke"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#63300f",
    d: "M562.534 170.846c-31.457-6.064-58.745-.379-82.622 14.402-8.338-48.512 73.905-62.914 82.622-14.402z",
    vectorEffect: "non-scaling-stroke"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2800",
    d: "M611.045 146.59c31.457-6.064 58.745-.379 82.622 14.402 8.338-48.891-73.905-63.293-82.622-14.402z",
    vectorEffect: "non-scaling-stroke"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M904.391 465.708v305.853c0 20.466-16.676 37.142-37.142 37.142H313.151c-20.466 0-37.142-16.676-37.142-37.142V467.982L590.2 543.024l314.191-77.316z",
    vectorEffect: "non-scaling-stroke"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e8ef",
    d: "M879.378 497.923L590.58 569.175l-289.178-68.978v265.3c0 10.233 8.339 18.571 18.572 18.571h540.832c10.233 0 18.571-8.338 18.571-18.571V497.923z",
    vectorEffect: "non-scaling-stroke"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M590.58 569.175l-288.798-68.978v265.3c0 10.233 8.338 18.571 18.57 18.571H590.58V569.175z",
    vectorEffect: "non-scaling-stroke"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#036aab",
    d: "M590.58 644.217h242.939v32.594h-242.94v-32.594zm0 67.462h242.939v32.594h-242.94v-32.594z",
    vectorEffect: "non-scaling-stroke"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#0399ed",
    d: "M347.64 644.217h242.94v32.594H347.64v-32.594zm242.94 100.056v-32.594H347.64v32.594h242.94z",
    vectorEffect: "non-scaling-stroke"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M446.18 622.993h30.7v148.568h-30.7z",
    vectorEffect: "non-scaling-stroke"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M360.906 488.448c76.558 18.192 153.116 36.763 229.294 54.955l-81.864 77.316c-53.06-31.078-105.74-65.567-147.43-132.271z",
    vectorEffect: "non-scaling-stroke"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M425.714 529.759c23.498 23.119 49.27 41.69 79.211 59.882l34.49-32.594-113.7-27.288z",
    vectorEffect: "non-scaling-stroke"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#7eaaba",
    d: "M819.875 488.448c-76.558 18.192-153.117 36.763-229.295 54.955l81.864 77.316c53.06-31.078 105.362-65.567 147.43-132.271z",
    vectorEffect: "non-scaling-stroke"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M754.687 529.759c-23.498 23.119-49.27 41.69-79.211 59.882l-34.49-32.594 113.7-27.288z",
    vectorEffect: "non-scaling-stroke"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "matrix(.94 0 0 .94 97.18 42.51)",
    vectorEffect: "non-scaling-stroke"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(70.09 81.52)",
    vectorEffect: "non-scaling-stroke"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 66.17,
    height: 66.17,
    x: -33.085,
    y: -33.085,
    fill: "#fffbfb",
    opacity: 0.81,
    rx: 0,
    ry: 0,
    transform: "matrix(8.38 0 0 5.77 782.66 893.58)",
    vectorEffect: "non-scaling-stroke"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M954.385 963.48c18.797-2.288 60.25-7.215 67.63 2.29 7.376 9.33-8.256 48.59-15.284 66.016-2.107 5.283 2.46 7.395 7.202 3.347 30.915-26.056 38.996-80.456 32.674-88.377-6.326-7.743-60.602-14.436-93.628 8.804-5.095 3.695-4.215 8.626 1.406 7.92z",
    vectorEffect: "non-scaling-stroke"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M783.974 1058.697c72.197 0 156.16-22.713 213.953-65.49 9.484-7.041 1.228-17.778-8.434-13.378-64.817 27.462-135.255 40.844-199.37 40.844-95.031 0-186.9-26.23-261.376-69.538-6.504-3.873-11.42 2.816-5.977 7.747 68.861 62.317 160.026 99.815 261.204 99.815z",
    vectorEffect: "non-scaling-stroke"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#252f3e",
    d: "M669.35 857.09c0 6.515.701 11.794 1.93 15.668a94.358 94.358 0 005.624 12.673c.876 1.41 1.228 2.82 1.228 4.052 0 1.762-1.053 3.524-3.339 5.283l-11.064 7.394c-1.581 1.054-3.165 1.584-4.568 1.584-1.758 0-3.514-.883-5.269-2.467a54.432 54.432 0 01-6.326-8.274 136.277 136.277 0 01-5.447-10.388c-13.698 16.198-30.915 24.297-51.64 24.297-14.757 0-26.523-4.225-35.131-12.673-8.608-8.452-13.001-19.723-13.001-33.802 0-14.967 5.269-27.113 15.984-36.266 10.716-9.156 24.945-13.731 43.04-13.731 5.97 0 12.119.527 18.62 1.406 6.497.883 13.172 2.29 20.199 3.873v-12.851c0-13.379-2.812-22.71-8.26-28.167-5.617-5.457-15.104-8.095-28.629-8.095-6.148 0-12.47.701-18.971 2.285a139.72 139.72 0 00-18.971 5.988 50.338 50.338 0 01-6.148 2.29c-1.229.348-2.108.526-2.813.526-2.456 0-3.688-1.759-3.688-5.457v-8.626c0-2.816.356-4.93 1.232-6.16.876-1.234 2.456-2.466 4.916-3.701 6.148-3.169 13.528-5.807 22.133-7.921 8.608-2.286 17.746-3.347 27.405-3.347 20.904 0 36.183 4.756 46.02 14.261 9.662 9.506 14.581 23.945 14.581 43.308v57.038h.353zm-71.318 26.76c5.796 0 11.77-1.057 18.092-3.168 6.323-2.114 11.944-5.988 16.686-11.267 2.812-3.346 4.92-7.042 5.974-11.267 1.054-4.226 1.755-9.331 1.755-15.316v-7.394a146.44 146.44 0 00-16.159-2.99 132.072 132.072 0 00-16.511-1.061c-11.77 0-20.378 2.29-26.173 7.042-5.796 4.756-8.608 11.445-8.608 20.245 0 8.274 2.107 14.436 6.5 18.662 4.215 4.4 10.363 6.515 18.44 6.515zm141.051 19.011c-3.161 0-5.269-.527-6.675-1.759-1.402-1.057-2.634-3.524-3.688-6.867l-41.278-136.08c-1.054-3.525-1.58-5.81-1.58-7.042 0-2.816 1.402-4.4 4.214-4.4h17.213c3.34 0 5.625.526 6.853 1.758 1.406 1.057 2.456 3.524 3.514 6.867l29.512 116.54 27.401-116.54c.876-3.524 1.93-5.81 3.336-6.867 1.406-1.057 3.863-1.759 7.027-1.759h14.052c3.339 0 5.621.527 7.027 1.759 1.406 1.057 2.635 3.524 3.336 6.867l27.754 117.95 30.391-117.95c1.05-3.524 2.279-5.81 3.51-6.867 1.407-1.057 3.689-1.759 6.854-1.759h16.333c2.812 0 4.393 1.407 4.393 4.4 0 .88-.175 1.76-.353 2.817a25.066 25.066 0 01-1.228 4.4L854.67 894.417c-1.057 3.52-2.285 5.806-3.691 6.863-1.403 1.058-3.689 1.763-6.675 1.763h-15.106c-3.339 0-5.624-.53-7.027-1.763-1.403-1.231-2.634-3.52-3.336-7.041l-27.227-113.546-27.052 113.371c-.88 3.521-1.933 5.81-3.34 7.042-1.402 1.232-3.862 1.759-7.023 1.759h-15.109zm225.722 4.756c-9.135 0-18.27-1.057-27.052-3.168-8.783-2.115-15.632-4.404-20.2-7.045-2.812-1.585-4.742-3.347-5.447-4.927a12.47 12.47 0 01-1.053-4.931v-8.978c0-3.696 1.406-5.458 4.04-5.458 1.054 0 2.108.178 3.161.527 1.054.356 2.635 1.057 4.393 1.762a95.376 95.376 0 0019.324 6.16c7.024 1.409 13.877 2.114 20.9 2.114 11.069 0 19.677-1.937 25.647-5.81 5.974-3.873 9.135-9.505 9.135-16.725 0-4.927-1.58-8.975-4.742-12.321-3.161-3.347-9.135-6.337-17.743-9.153l-25.468-7.925c-12.823-4.047-22.31-10.032-28.106-17.956-5.796-7.747-8.783-16.373-8.783-25.525 0-7.395 1.58-13.91 4.742-19.541 3.161-5.632 7.376-10.563 12.649-14.436 5.269-4.048 11.239-7.042 18.266-9.153 7.028-2.114 14.404-2.994 22.133-2.994 3.866 0 7.906.178 11.769.705 4.04.527 7.729 1.232 11.417 1.937 3.514.88 6.853 1.758 10.014 2.812 3.162 1.061 5.621 2.115 7.377 3.172 2.46 1.41 4.218 2.816 5.272 4.4 1.054 1.41 1.58 3.347 1.58 5.81v8.277c0 3.699-1.406 5.636-4.04 5.636-1.406 0-3.688-.705-6.675-2.115-10.014-4.575-21.257-6.864-33.727-6.864-10.011 0-17.918 1.585-23.361 4.927-5.447 3.347-8.256 8.452-8.256 15.672 0 4.927 1.755 9.149 5.269 12.495 3.514 3.347 10.01 6.693 19.32 9.683l24.945 7.925c12.649 4.048 21.78 9.683 27.227 16.9s8.081 15.489 8.081 24.645c0 7.569-1.58 14.436-4.567 20.42-3.162 5.985-7.377 11.268-12.824 15.493-5.446 4.4-11.943 7.569-19.498 9.858-7.903 2.464-16.162 3.699-25.119 3.699z",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default __webpack_public_path__ + "static/fonts.37ac5e87.svg";
export { SvgFonts as ReactComponent };